"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = void 0;
const react_1 = require("react");
function useTimeout() {
    const timeoutRef = (0, react_1.useRef)();
    const clearDebouncedTimeout = (0, react_1.useCallback)(() => {
        const dTimeout = timeoutRef.current;
        dTimeout && clearTimeout(dTimeout);
    }, []);
    const debouncedCall = (0, react_1.useCallback)((callback, ms) => {
        // remove existing timeout
        clearDebouncedTimeout();
        // set new timeout
        timeoutRef.current = setTimeout(callback, ms);
        return clearDebouncedTimeout;
    }, [clearDebouncedTimeout]);
    return [debouncedCall, clearDebouncedTimeout];
}
exports.useTimeout = useTimeout;
//# sourceMappingURL=timeout.hook.js.map